import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import { ApiService } from 'services';
import { addSupportingDoc, fileUploadError } from 'actions';
import { getStorageSetting } from 'common/storage';

import { getWhdStatementByEnumValue } from 'common/supportingDocuments/whdStatements';
import FileUpload from 'components/Common/FileUpload';
import FileContent from 'components/Common/FileContent';
import EvidentiaryDocs from 'components/EvidentiaryDocs';
import LocalisedMessage from 'components/Common/LocalisedMessage';
import { injectIntl } from 'react-intl';

class SupportingDocuments extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    documents: PropTypes.arrayOf(PropTypes.shape({})),
    isFormGroup: PropTypes.bool,
    locale: PropTypes.string.isRequired,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired
    }).isRequired
  };

  static defaultProps = {
    documents: [],
    isFormGroup: false
  };

  constructor(props) {
    super(props);

    const files = getStorageSetting('files') || [];

    this.state = {
      supportingDocType: '',
      files
    };
  }

  handleChange(event) {
    this.setState({ supportingDocType: event.target.value });
  }

  static onViewSupportingDocument(file) {
    if (file) {
      window.open(`customers/supporting-docs/${ file.id }`, '_blank'); // to open new page
    }
  }

  onFileUploadCancel(file) {
    const { dispatch, intl } = this.props;
    const error = {
      code: 400,
      message: `${ intl.formatMessage({ id: 'supportingDocuments.onFileUploadCancel' }, { FileName: file.name }) }`
    };
    dispatch(fileUploadError(error));
  }

  onFileUploadError(file, error) {
    const { dispatch, intl } = this.props;
    error.message = `${ intl.formatMessage({ id: 'supportingDocuments.onFileUploadCancel' }, { FileName: file.name }) }  ${ error.message }`;
    dispatch(fileUploadError(error));
  }

  onFileUploadSuccess(file, response) {
    const { dispatch } = this.props;
    dispatch(addSupportingDoc(response));
  }

  render() {
    const { files, supportingDocType } = this.state;
    const { documents, id, isFormGroup, locale } = this.props;

    const filteredDocs = documents
      ?.filter(doc => !getWhdStatementByEnumValue(doc.type));
    const displayDocs = filteredDocs && filteredDocs.sort((a, b) => {
      const lines = Math.ceil(a.typeDescription.length / 28) + Math.ceil((a.originalFileName || a.fileName).length / 28)
        - (Math.ceil(b.typeDescription.length / 28) + Math.ceil((b.originalFileName || b.fileName).length / 28));

      if (lines === 0) {
        if (a.typeDescription === b.typeDescription) {
          return (a.originalFileName || a.fileName) > (b.originalFileName || b.fileName) ? 1 : -1;
        }

        return a.typeDescription > b.typeDescription ? 1 : -1;
      }

      return lines > 0 ? 1 : -1;
    });

    return <div id="supporting-documents" className="supporting-documents">
      <div className="row">
        <div className="col">
          <p className="mb-2"><LocalisedMessage id="supportingDocuments.dropdown.title" /></p>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <EvidentiaryDocs
            supportingDocType={ supportingDocType }
            handleChange={ e => this.handleChange(e) }
          />
        </div>
        <div className="col-12 mv-1">
          <FileUpload
            postUrl={ ApiService.getFileUploadUrl() }
            acceptedFiles="application/pdf,.jpg,.png,.bmp,.msg,.doc,.docx,.jpeg,.tiff,.gif,.tif,.xls,.xlsx"
            maxFilesize={ files.maxFilesize }
            docCategory="supportingdocument"
            docType={ supportingDocType != null ? supportingDocType : '' }
            id={ id }
            linkType={ isFormGroup ? 'formGroup' : 'form' }
            removeFileAfterUpload
            onFileUploadCancel={ file => this.onFileUploadCancel(file) }
            onFileUploadSuccess={ (file, response) => this.onFileUploadSuccess(file, response) }
            onFileUploadError={ (file, error) => this.onFileUploadError(file, error) }
            locale={ locale }
          />
        </div>
      </div>
      <div className="row">
        { documents && documents.length > 0 && <div className="col-12">
          <h3 className="text-bold mb-2"><LocalisedMessage id="supportingDocuments.uploadedDocuments" /></h3>
        </div> }
        { displayDocs && displayDocs.length > 0 && displayDocs.map(item => item
          && <div key={ item.id } className="col-12 col-md-6 mb-2">
            <FileContent item={ item } />
          </div>)}
      </div>
    </div>;
  }
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapDispatchToProps
)(injectIntl(SupportingDocuments));
